import React from 'react';
import { User } from 'firebase/auth';
import { useActor } from '@xstate/react';
import { useHistory } from 'react-router-dom';
import { CaseTypeSelection as CaseTypeSelectionBase } from '../submitCase/CaseTypeSelection';
import { useEditCaseContext } from '../../context/EditCaseContext';
import { CaseType } from '../../stateMachines/submitCase/caseType';

interface CaseTypeSelectionProps {
  currentUser: User;
}

const CaseTypeSelection: React.FC<CaseTypeSelectionProps> = ({
  currentUser,
}) => {
  const { editCaseService } = useEditCaseContext();
  const [state, send] = useActor(editCaseService);
  const isLoading = state.matches({ caseType: 'load' });
  const history = useHistory();

  return (
    <CaseTypeSelectionBase
      currentUser={currentUser}
      isLoading={isLoading}
      onNext={() => send({ type: 'NEXT' })}
      onChange={(value) => send({ type: 'SET_CASE_TYPE', caseType: value })}
      value={state.context.caseType}
      isPriorityAvailable={state.context.priorityAvailable}
      businessStartTime={state.context.businessStart}
      businessEndTime={state.context.businessEnd}
      priorityFee={state.context.priorityFeePrice}
      onBack={() => history.goBack()}
      initialValue={
        state.context.case?.priority ? CaseType.PRIORITY : CaseType.STANDARD
      }
    />
  );
};

export default CaseTypeSelection;
